module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-147.1ff1c39c.svg";